/**
 * RNA-seq pipeline helpers.
 *
 * Keep the preview UI data-driven: derive the pipeline badge and
 * description2 from the selected analysis service in product_line.config.json.
 */

const RNASEQ_PIPELINE_LABEL_OVERRIDES = {
  // Product request: when A-B004 is selected, the preview should show "Basic".
  'A-B004 RNAseq_Basic': 'Basic',
  'A-B005 RNAseq_Advanced': 'Advanced',
  'A-B006 RNAseq_Customized_1': 'Customized_1',
  'A-B007 RNAseq_Customized_2': 'Customized_2',
  'P-0013 mRNAseq: Illumina 建庫 定序 6G 進階分析': 'Advanced',
  'P-0014 Total RNAseq: Illumina 建庫 定序 10G 進階分析': 'Advanced'
};

const normalizeServiceCatalog = (serviceCatalog = {}) => {
  if (!serviceCatalog || typeof serviceCatalog !== 'object') {
    return [];
  }

  return Object.values(serviceCatalog).flatMap(category => (
    Array.isArray(category) ? category : []
  ));
};

export const findServiceConfigByValue = (serviceCatalog = {}, serviceName = '') => {
  if (!serviceName) return null;

  return normalizeServiceCatalog(serviceCatalog).find(item => item?.value === serviceName) || null;
};

const inferPipelineLabel = (serviceConfig = {}, serviceName = '') => {
  return RNASEQ_PIPELINE_LABEL_OVERRIDES[serviceName] || null;
};

export const getRNAseqPipelineInfo = ({
  serviceItems = [],
  serviceCatalog = {}
} = {}) => {
  const items = Array.isArray(serviceItems) ? serviceItems : [];

  const selectedService = items
    .flatMap(item => (Array.isArray(item?.services) ? item.services : []))
    .find(svc => {
      const serviceName = svc?.service;
      if (!serviceName) return false;

      const serviceConfig = findServiceConfigByValue(serviceCatalog, serviceName);
      return serviceConfig?.isRNAseq === true;
    });

  if (!selectedService?.service) return null;

  const serviceConfig = findServiceConfigByValue(serviceCatalog, selectedService.service);
  if (!serviceConfig) return null;

  const pipelineLabel = inferPipelineLabel(serviceConfig, selectedService.service);
  if (!pipelineLabel) return null;

  return {
    serviceValue: selectedService.service,
    pipelineLabel,
    description2: serviceConfig.description2 || ''
  };
};
